import React from 'react';

import clsx from 'clsx';

interface BooleanCellProps {
  value?: unknown;
  render?: () => React.ReactNode;
}

function BooleanCell({ value, render }: BooleanCellProps) {
  if (render) {
    return <>{render()}</>;
  }

  return (
    <span
      className={clsx('data-cell__boolean', {
        'data-cell__boolean--true': !!value,
        'data-cell__boolean--false': !value,
      })}
    >
      {value ? '✓' : '✗'}
    </span>
  );
}

export default BooleanCell;
